import React from "react";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import CloseIcon from "@readai/icons/uui/XClose";
import IconButton, {
  IconButtonProps,
} from "@readai/pulse/components/IconButton";

export const ModalCloseButton = styled<React.FC<IconButtonProps>>((props) => (
  <IconButton {...props}>
    <CloseIcon />
  </IconButton>
))(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.outline.default,
  color: theme.palette.icon.weak,
  borderRadius: theme.corners.base,
  height: "32px",
  width: "32px",
}));

export const ModalTitle = ({ ...props }: TypographyProps) => (
  <Typography
    variant="h2"
    sx={{ color: "text.default", lineHeight: "25px", ...props.sx }}
    {...props}
  >
    {props.children}
  </Typography>
);
